module.exports = __webpack_public_path__ + "static/media/a4-p.e2598ce9.png";